import React from 'react';
import { Helmet } from "react-helmet";

const OneTab = () => {
  let URL = `${process.env.REACT_APP_CDN_URL}/assets/javascripts/one-tab-google/staging.js`
  return (
    <Helmet>
      <script src={URL} async="" defer=""></script>
    </Helmet>
  )
}

export default OneTab;